import type {FilterCreator, Filter, Listener} from './types';

// we forward the inner return value so that we don't swallow
// any signal to callFirstMatch that it should exit early
export const withModifier: FilterCreator =
  (test) => (callback: Listener) => (event) => {
    if (typeof callback === 'function' && test(event)) {
      return callback(event);
    }
  };

// @ts-expect-error - TS2322 - Type 'boolean | undefined' is not assignable to type 'boolean'.
export const withAlt: Filter = withModifier((event) => event.altKey);
export const withControl: Filter = withModifier(
  // @ts-expect-error - TS2322 - Type 'boolean | undefined' is not assignable to type 'boolean'.
  (event) => event.ctrlKey || event.metaKey
);
export const withDefaultPrevented: Filter = withModifier(
  // @ts-expect-error - TS2322 - Type 'boolean | undefined' is not assignable to type 'boolean'.
  (event) => event.defaultPrevented
);
export const withDefaultNotPrevented: Filter = withModifier(
  (event) => !event.defaultPrevented
);
// @ts-expect-error - TS2322 - Type 'boolean | undefined' is not assignable to type 'boolean'.
export const withShift: Filter = withModifier((event) => event.shiftKey);
